import React from 'react';
import PrescriptionTable from './Components/PresciptionsTable';

const PrescriptionsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <PrescriptionTable />
      </div>
    </div>
  );
};

export default PrescriptionsPage;
